import { formatDateToYYYYMMDD } from './date'

export const CONTRACT_TYPE_LABEL = {
	single: '단기 계약',
	long_term: '장기 계약',
	year_first_half: '기간 계약 · 상반기',
	year_second_half: '기간 계약 · 하반기',
	both: '기간 계약 · 상·하반기',
}

export const REGION_LABEL = {
	DOMESTIC: '국내',
	INTERNATIONAL: '해외',
}

export function stripHtml(html) {
	if (!html) return ''
	return String(html)
		.replace(/<[^>]*>/g, ' ')
		.replace(/&nbsp;/gi, ' ')
		.replace(/\s+/g, ' ')
		.trim()
}

export function formatWon(n) {
	if (n == null || Number.isNaN(Number(n))) return null
	return Number(n).toLocaleString('ko-KR')
}

function payrollHint(cycles) {
	if (cycles === 'weekly') return '주급'
	if (cycles === 'perGame') return '경기당'
	return ''
}

/** Prisma camelCase + 구 클라이언트 오타(payRollCycles) 호환 */
function contractPayrollCycles(contract) {
	if (!contract) return undefined
	return contract.payrollCycles ?? contract.payRollCycles
}

export function compensationBlocks(row) {
	const domestic = row.domesticContract
	const overseas = row.overseasContract
	const term = row.termContract
	const blocks = []

	if (domestic) {
		const unit = payrollHint(contractPayrollCycles(domestic))
		const through = formatWon(domestic.weeklySalaryCutThrough)
		const fail = formatWon(domestic.weeklySalaryCutFail)
		if (through)
			blocks.push({
				key: 'd-through',
				label: '컷통과',
				value: through,
				unit: unit ? `원 · ${unit}` : '원',
			})
		if (fail)
			blocks.push({
				key: 'd-fail',
				label: '컷탈락',
				value: fail,
				unit: unit ? `원 · ${unit}` : '원',
			})
	}
	if (overseas && blocks.length === 0) {
		const unit = payrollHint(contractPayrollCycles(overseas))
		const through = formatWon(overseas.weeklySalaryCutThrough)
		const fail = formatWon(overseas.weeklySalaryCutFail)
		if (through)
			blocks.push({
				key: 'o-through',
				label: '컷통과',
				value: through,
				unit: unit ? `원 · ${unit}` : '원',
			})
		if (fail)
			blocks.push({
				key: 'o-fail',
				label: '컷탈락',
				value: fail,
				unit: unit ? `원 · ${unit}` : '원',
			})
	}
	if (term && blocks.length === 0) {
		const amt = formatWon(term.salaryAmountForPeriod)
		const unit = payrollHint(contractPayrollCycles(term))
		if (amt)
			blocks.push({
				key: 'term',
				label: '기간 급여',
				value: amt,
				unit: unit ? `원 · ${unit}` : '원',
			})
	}

	return blocks
}

export function contractPeriodLine(row) {
	const start = row.contract_started_at ?? row.contractStartedAt
	const end = row.contract_ended_at ?? row.contractEndedAt
	if (!start && !end) return null
	const a = start ? formatDateToYYYYMMDD(new Date(start)) : ''
	const b = end ? formatDateToYYYYMMDD(new Date(end)) : ''
	if (a && b) return `계약 기간 ${a} ~ ${b}`
	if (a) return `계약 시작 ${a}`
	return null
}

/** 등록 시각 기준 상대 문구 (예: 54분 전) */
export function formatRelativeTimeKo(createdAtInput) {
	if (!createdAtInput) return ''
	const createdAt = new Date(createdAtInput)
	if (Number.isNaN(createdAt.getTime())) return ''
	const now = new Date()
	const timeDiff = Math.max(0, now.getTime() - createdAt.getTime())
	const minutes = Math.floor(timeDiff / (1000 * 60))
	const hours = Math.floor(timeDiff / (1000 * 60 * 60))
	const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
	const weeks = Math.floor(days / 7)
	const months = Math.floor(days / 30)

	if (minutes < 1) return '방금 전'
	if (minutes < 60) return `${minutes}분 전`
	if (hours < 24) return `${hours}시간 전`
	if (days < 7) return `${days}일 전`
	if (weeks < 4) return `${weeks}주 전`
	return `${months}개월 전`
}
